module.exports = __webpack_public_path__ + "static/media/cec.e9740392.JPG";